import { instance } from '@/api/instances'

const getTestResultImageURL = async (
  store,
  { personId, imageId, provider, resultType }
) => {
  try {
    return await instance.post(
      `persons/${personId}/test_results/images/${imageId}`,
      {
        json: {
          provider,
          resultType
        }
      }
    )
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'pillars/testResults/getTestResultImageURL' },
      { root: true }
    )
  }
}

const deleteTestResultFile = async (store, { personId, id }) => {
  try {
    await instance.delete(`persons/${personId}/test_result_file/${id}`)
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'pillars/testResults/deleteTestResultFile' },
      { root: true }
    )
  }
}

const getLabTestResults = async (store, personId) => {
  try {
    return await instance.get(`persons/${personId}/test_results/v2`)
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'pillars/testResults/getLabTestResults' },
      { root: true }
    )
    return []
  }
}

const getImageTestResults = async (store, personId) => {
  try {
    return await instance.get(`persons/${personId}/test_results/images`)
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'pillars/testResults/getImageTestResults' },
      { root: true }
    )
    return []
  }
}

const getFilesTestResults = async (store, personId) => {
  try {
    return await instance.get(`persons/${personId}/test_result_files`)
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'pillars/testResults/getFilesTestResults' },
      { root: true }
    )
    return []
  }
}

const openTestResultFile = async (store, { file }) => {
  try {
    const { url } = await store.dispatch('file/getFile', file.url, {
      root: true
    })

    return url
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'pillars/testResults/openTestResultFile' },
      { root: true }
    )
  }
}

const getValidExamsForCode = async (
  store,
  { personId, aliceCode, deadlineDate }
) => {
  try {
    return await instance.get(
      `persons/${personId}/test_results/exam/file?examRequestDate=${deadlineDate}&aliceCode=${aliceCode}`
    )
  } catch (error) {
    store.dispatch(
      'errors/setError',
      {
        error,
        request: 'pillars/testResults/findValidExamResultByAliceCode'
      },
      { root: true }
    )
  }
}

export default {
  getTestResultImageURL,
  deleteTestResultFile,
  openTestResultFile,
  getValidExamsForCode,
  getLabTestResults,
  getImageTestResults,
  getFilesTestResults
}
